import { useState } from "react"
import { CircleAlertIcon, LoaderCircleIcon, WrenchIcon } from "lucide-react"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { cn } from "@/lib/utils"

export interface ChatToolCall {
  name: string
  args?: any
  result?: any
  done: boolean
}

function Block({ value }: { value: any }) {
  return <pre className="max-h-64 overflow-auto whitespace-pre-wrap break-words rounded border bg-muted/50 p-2 text-xs">{typeof value === "string" ? value : JSON.stringify(value, null, 2)}</pre>
}

export function ChatToolCalls({ calls }: { calls: ChatToolCall[] }) {
  const [open, setOpen] = useState<ChatToolCall | null>(null)

  return <div className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground">
    {calls.map((call, index) => {
      const failed = !!call.result?.error
      const Icon = !call.done ? LoaderCircleIcon : failed ? CircleAlertIcon : WrenchIcon
      return <button key={index} type="button" onClick={() => setOpen(call)} title={failed ? call.result.error : undefined}
        className={cn("inline-flex items-center gap-1 rounded border bg-background px-1.5 py-0.5 font-mono hover:bg-muted", failed && "text-red-600")}>
        <Icon className={cn("size-3", !call.done && "animate-spin")} />{call.name}
      </button>
    })}
    <Dialog open={!!open} onOpenChange={value => !value && setOpen(null)}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-mono">{open?.name}</DialogTitle>
        </DialogHeader>
        <div className="min-h-0 space-y-3 overflow-auto">
          <div className="space-y-1">
            <div className="text-sm font-medium">Arguments</div>
            <Block value={open?.args ?? {}} />
          </div>
          <div className="space-y-1">
            <div className="text-sm font-medium">Result</div>
            {open?.done ? <Block value={open.result ?? null} /> : <p className="text-sm text-muted-foreground">Still running.</p>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  </div>
}
